import { Component } from '@angular/core';

@Component({
	templateUrl: '../../../../../../assets/svg/agentApp.svg',
})
export class AgentAppComponent {}
